import React from "react";
import type { ProductEntity } from "../../../../../../domain/types/product";
import { PREVIEW_COLORS } from "../../constants";

interface PreviewBestSellerProps {
  productsData: ProductEntity[] | null;
  title?: string | null;
  subtitle?: string | null;
}

export const PreviewBestSeller = ({
  productsData,
  title,
  subtitle,
}: PreviewBestSellerProps) => {
  return (
    <div className="p-[4rem] flex flex-col">
      <div className="mb-[3rem]">
        <h2
          className="text-[1.375rem] font-semibold mb-[0.5rem]"
          style={{ color: PREVIEW_COLORS.sectionTitle }}
        >
          {title || "베스트셀러"}
        </h2>
        <div style={{ color: PREVIEW_COLORS.sectionSubtitle }}>
          {subtitle || "가장 많이 선택한 인쇄 상품"}
        </div>
      </div>
      <div>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-[16px] / items-start">
          {productsData?.map((item) => {
            if (item.isBestSeller) {
              return (
                <div>
                  <div className="w-full h-full relative mb-[1.25rem]">
                    <div
                      className="w-full rounded-full aspect-[1/1] drop-shadow-xl"
                      style={{
                        backgroundColor: PREVIEW_COLORS.thumbnailPlaceholder,
                      }}
                    >
                      <img
                        src={item.thumbnail ?? ""}
                        alt="썸네일 이미지."
                        className="object-cover h-full rounded-full w-full"
                      />
                    </div>
                  </div>
                  <h3
                    className="font-semibold text-[1rem]"
                    style={{ color: PREVIEW_COLORS.bestSeller.productName }}
                  >
                    {item.name}
                  </h3>
                  <div
                    className="text-[0.75rem]"
                    style={{ color: PREVIEW_COLORS.bestSeller.productDesc }}
                  >
                    {item.description}
                  </div>
                  <div
                    className="font-bold text-[0.9375rem]"
                    style={{ color: PREVIEW_COLORS.bestSeller.productPrice }}
                  >
                    <span className="text-[1.375rem]">
                      ~{item.priceTiers?.[0]?.price ?? "-"}
                    </span>
                    원
                  </div>
                </div>
              );
            } else {
              return <></>;
            }
          })}
        </div>
      </div>
    </div>
  );
};
